var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ul", { staticClass: "setting" }, [
    _c("li", [
      _c("div", { staticClass: "item-block" }, [
        _c("span", { staticClass: "text-title" }, [
          _vm._v(_vm._s(_vm.$ln("遊戲音效"))),
        ]),
        _c("label", { staticClass: "switch" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.isSoundOpen,
                expression: "isSoundOpen",
              },
            ],
            attrs: { type: "checkbox" },
            domProps: {
              checked: _vm.isSoundOpen,
              checked: Array.isArray(_vm.isSoundOpen)
                ? _vm._i(_vm.isSoundOpen, null) > -1
                : _vm.isSoundOpen,
            },
            on: {
              input: _vm.setSoundOpen,
              change: function ($event) {
                var $$a = _vm.isSoundOpen,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.isSoundOpen = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.isSoundOpen = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.isSoundOpen = $$c
                }
              },
            },
          }),
          _c("span", { staticClass: "slider round" }),
        ]),
      ]),
    ]),
    _c("li", [
      _c("div", { staticClass: "item-block" }, [
        _c("span", { staticClass: "text-title" }, [
          _vm._v(_vm._s(_vm.$ln("遊戲音樂"))),
        ]),
        _c("label", { staticClass: "switch" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.isMusicOpen,
                expression: "isMusicOpen",
              },
            ],
            attrs: { type: "checkbox" },
            domProps: {
              checked: _vm.isMusicOpen,
              checked: Array.isArray(_vm.isMusicOpen)
                ? _vm._i(_vm.isMusicOpen, null) > -1
                : _vm.isMusicOpen,
            },
            on: {
              input: _vm.setMusicOpen,
              change: function ($event) {
                var $$a = _vm.isMusicOpen,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.isMusicOpen = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.isMusicOpen = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.isMusicOpen = $$c
                }
              },
            },
          }),
          _c("span", { staticClass: "slider round" }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }